import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: calc(7.3vh + 40px) 0 0 0;
`;

export const TitleBox = styled.div`
  width: 920px;
  color: #333;
  font-family: 'Pretendard Variable';
  font-size: 32px;
  font-style: normal;
  font-weight: 600;
  padding: 45px 0 25px 0;
`;

export const Desc = styled.p`
  color: #707070;
  font-family: 'Pretendard Variable';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  line-height: 150%;
`;
